export function useTutorial(tutorialId) {
    const STORAGE_KEY = 'showedtutorials';

    const getTutorials = () => {
        try {
            return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        } catch {
            return [];
        }
    };

    const isShowed = () => {
        return getTutorials().includes(tutorialId);
    };

    const markAsShowed = () => {
        const tutorials = getTutorials();
        if (!tutorials.includes(tutorialId)) {
            tutorials.push(tutorialId);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(tutorials));
        }
    };

    return { isShowed, markAsShowed };
}
